import './Footer.css';
import { Link } from 'react-router-dom';
import { PhoneIcon } from '@heroicons/react/24/outline';

const Footer = () => {
  const blueStarLogo = 'https://assets.bluestar-rowing.com/assets/logos/blue_star_logo.png';

  return (
    <footer className="footer">
      {/* Top Section */}
      <div className="footer-top">
        <nav className="footer-nav">
          <Link to="/">Home</Link>
          <Link to="/about">About Us</Link>
          <a href="#purpose">Our Purpose</a>
          <a href="#blog">Blog</a>
          <a href="#contact">Contact</a>
        </nav>
      </div>

      {/* Divider */}
      <div className="footer-divider"></div>

      {/* Middle Section */}
      <div className="footer-middle">
        <div className="footer-contact">
          <div className="footer-contact-items">
            <div className="footer-contact-item">
              <PhoneIcon className="footer-icon" />
              <span>+44 7492 554343</span>
            </div>
          </div>
        </div>

        <div className="footer-logo">
          <img 
            src={blueStarLogo} 
            alt="Blue Star Rowing Logo" 
            className="footer-logo-icon"
          />
        </div>

        <div className="footer-cta">
          <a 
            href="https://www.gofundme.com/f/blue-star-atlantic-row-2026" 
            target="_blank" 
            rel="noopener noreferrer"
            className="footer-donate-button"
          >
            DONATE TODAY
          </a>
          <div className="footer-social">
            <a 
              href="https://www.instagram.com/bluestar_rowing/" 
              target="_blank" 
              rel="noopener noreferrer"
              className="footer-social-icon"
              aria-label="Instagram"
            >
              <svg viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
              </svg>
            </a>
          </div>
        </div>
      </div>

      {/* Divider */}
      <div className="footer-divider"></div>

      {/* Bottom Section */}
      <div className="footer-bottom">
        <div className="footer-bottom-left">
          <a 
            href="https://www.worldstoughestrow.com" 
            target="_blank" 
            rel="noopener noreferrer"
          >
            World's Toughest Row
          </a>
          <a href="#privacy">Privacy Policy</a>
        </div>
        <div className="footer-bottom-center">
          <p>© 2025 Blue Star Rowing.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
